import { button } from "@/helper/locale/base/base_button.en"
import base_otp from "@/helper/locale/base/base_otp.en"
import { date } from "@/helper/locale/base/base_date.en"

export default {
    base_button: button,
    base_otp,
    base_date: date,

    module: {
        exchange_name: "The 1 Points"
    },

    init: {
        connectTheOne: "Please connect with The1 account",
        theOneNumber: "The1 Number : ",
    },

    buttons: {
        continue: "Continue",
        backToHome: "Back to Home",
        logout: "Log out",
        tryAgain: "Try Again"
    },
    convert: {
        title: {
            convert: "Convert",
            textTo: "to"
        },
        theOneNumber: "The 1 Member’s No. : ",
        theOneName: "Name : ",
        enter: "Your phone number",
        contact_number: {
            name: "Your phone number",
            placeholder: "Phone number",
            required: "Please True number",
            too_short: "",
            invalid: ""
        },
        identifier_no: {
            name: "Your phone number",
            placeholder: "",
            required: "",
            too_short: "",
            invalid: ""
        },
        current_point: "Your {0}",
        after_point: "After conversion",
        please_enter: "Enter",
        continue: "Continue",

        not_found_err_title: "{0} Not Found",
        not_found_err: "Your entered {0} {1} has not found on our member system.</br></br></br></br>Please try again or enter another {0}.",

        not_verified_err: "Cannot topup because user identity not verified",
        user_account_frozen_err: "Cannot topup because user account frozen",
        exceed_daily_err: "Cannot topup because user has or will exceed daily topup volume",
        balance_limit_err: "Cannot topup because user's cash balance has or will exceed wallet balance limit",

        update_err_title: "Update {0}",

        convert_err_title: "Point Conversion Error",
        convert_err: "Please contact our call center at</br>",

        other_err_title: "Something Went Wrong",
        other_err: "Sorry, We are not able to process your request. Please try again.",

        point_not_enough_err: "Sorry, point balance is not enough. Please check your point again.",
        topup_too_high: "Cannot topup because topup amount is too high.",
        topup_too_low: "Cannot topup because topup amount is too low.",

        re_enter: "Re-Enter",
        close: "Close",
        back_to_campaign: "Back to campaign",

        retry: "Try Again",
        back: "Back"
    },
    result: {
        successfully: "Points Converted Successfully",
        new_point: "New {0}",
        your_convert: "You've converted",
        please_check_balance: "Please check your remaining balance through ShopeePay Application",
        back_to_campaign: "Back to Home"
    },
    ptmax: {
        not_found_card: "PT Max Card Number Not Found",
        not_found_card_message: "Your entered PT Max Card Number {xxx-xxx-xxxx} has not found on our member system. <br/><br/>Please try again or enter another PT Max Card Number."
    },
    confirm: {
        title: "Confirm to Convert",
        member: "Member",
        warning_text: "This conversion can not be undone",
        submit: "Confirm",
        cancel: "Cancel"
    },
    otp: {
        headline: 'OTP Confirmation',
        contact_number_lbl: "We've sent OTP to your number<br/>{0}",
        ref_code: 'Reference code : ',

        please_enter_otp: 'Please enter OTP',
        time_left: 'Resend OTP in',
        second: 'minutes',

        required: 'Please enter your OTP.',
        too_short: 'Please enter otp',
        otp_timeout: 'OTP time out in',
        resend_otp: 'Resend OTP',

        incorrect_otp: 'OTP is incorrect. Please Try Again',
        cancel: "Cancel",
        btn_confirm: "Submit and Convert"
    },
    errors: {
        pointConversionError: {
            title: "Point Conversion Error",
            message: "Please contact our call center <br /> {0}"
        },
        somethingWrong: {
            title: "Something Went Wrong",
            message: "Sorry, we are not able to proceed your request.<br />Please try again"
        },
        login: {
            title: "Login Error",
            message: "Please contact our call center<br />02-660-1000"
        },
        accountBlocked: {
            message: "Your account has been blocked.<br />Please contact our call center<br />{0}"
        },
        fullQuota: {
            title: "Something Went Wrong",
            message: "Your account has reached the point transfer limitation.<br />Please try again next month."
        }
    },
    logout: {
        title: "Sign Out Confirmation",
        text: "Are you sure you want to sign out?",
        btnOk: "Yes, Sign me out",
        btnCancel: "No, Close and Stay"
    },
    login: {
        btnLogin: "Login The 1 member"
    }
}
